import Dialog from '../dialog';

export default class Cookiewall {
    constructor() {
        this.cookie = this.getCookie('Cookieconsent');
        this.checkDialoguesTries = 0;

        this.checkCookieDialogues();
    }
    
    getCookie(name) {
        const value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return value ? value[2] : null;
    }

    init() {
        if (document.getElementById('cookiewall')) {
            this.wallDialog = new Dialog(document.getElementById('cookiewall'));
        }

        if (document.getElementById('cookiesettings')) {
            this.settingsDialog = new Dialog(document.getElementById('cookiesettings'));
        }
    }

    checkCookieDialogues() {
        if (this.cookie && document.getElementById('cookiesettings')) {
            this.init();
        } else if (document.getElementById('cookiewall') && document.getElementById('cookiesettings')) {
            this.init();
        } else {
            setTimeout(() => {
                // After 3 minutes (180.000ms), stop trying
                if (this.checkDialoguesTries < 180000) {
                    this.checkCookieDialogues();
                    this.checkDialoguesTries += 1;
                }
            }, 100);
        }
    }
}